import React from 'react';
import { NavLink } from 'react-router-dom'

const Terms_and_Conditions = () => {
    return(
        <div className="container">
            <NavLink to="/"> Home </NavLink>
            <p> Please work </p>
        </div>
    )
}

export default Terms_and_Conditions;


// WEBPACK FOOTER //
// ./src/Pages/terms/tandc.js